import './Icon.scss';
import React, { FC } from 'react';
import classNames from 'classnames';

export type IconType =
    | 'arrow'
    | 'angle'
    | 'angleDouble'
    | 'alignment'
    | 'caret'
    | 'chevron'
    | 'back'
    | 'add'
    | 'close'
    | 'crop'
    | 'delete'
    | 'edit'
    | 'enableEditing'
    | 'extras'
    | 'linkExternal'
    | 'linkup'
    | 'navigation'
    | 'unlink'
    | 'login'
    | 'logout'
    | 'remove'
    | 'reset'
    | 'save'
    | 'sort'
    | 'enableSort'
    | 'upload'
    | 'user'
    | 'service'
    | 'home'
    | 'sitemap'
    | 'imprint'
    | 'privacy'
    | 'unpublished'
    | 'newsletter'
    | 'contact'
    | 'bold'
    | 'italic'
    | 'listOl'
    | 'listUl'
    | 'table'
    | 'photo'
    | 'undo'
    | 'redo'
    | 'link'
    | 'quality'
    | 'fps'
    | 'pause';

type IconProps = {
    className?: string;
    icon: IconType;
};

const Icon: FC<IconProps> = ({ icon = 'arrowHead', className = '' }) => {
    return (
        <span className={classNames('Icon', `Icon-${icon}`, className)}></span>
    );
};

export default Icon;
